import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Observable} from 'rxjs/Observable';
import { Injectable, EventEmitter } from '@angular/core';

import { WrappedResponse } from './wrapped-response';
import { environment } from './../../environments/environment';

const counties: string[] = [
  'ALAMANCE',
  'ALEXANDER',
  'ALLEGHANY',
  'ANSON',
  'ASHE',
  'AVERY',
  'BEAUFORT',
  'BERTIE',
  'BLADEN',
  'BRUNSWICK',
  'BUNCOMBE',
  'BURKE',
  'CABARRUS',
  'CALDWELL',
  'CAMDEN',
  'CARTERET',
  'CASWELL',
  'CATAWBA',
  'CHATHAM',
  'CHEROKEE',
  'CHOWAN',
  'CLAY',
  'CLEVELAND',
  'COLUMBUS',
  'CRAVEN',
  'CUMBERLAND',
  'CURRITUCK',
  'DARE',
  'DAVIDSON',
  'DAVIE',
  'DUPLIN',
  'DURHAM',
  'EDGECOMBE',
  'FORSYTH',
  'FRANKLIN',
  'GASTON',
  'GATES',
  'GRAHAM',
  'GRANVILLE',
  'GREENE',
  'GUILFORD',
  'HALIFAX',
  'HAYWOOD',
  'HENDERSON',
  'HERTFORD',
  'HOKE',
  'HYDE',
  'IREDELL',
  'JACKSON',
  'JONES',
  'LENOIR',
  'LINCOLN',
  'MACON',
  'MADISON',
  'MARTIN',
  'MCDOWELL',
  'MECKLENBURG',
  'MITCHELL',
  'MONTGOMERY',
  'MOORE',
  'NASH',
  'NEW HANOVER',
  'NORTHAMPTON',
  'ONSLOW',
  'ORANGE',
  'PAMLICO',
  'PASQUOTANK',
  'PENDER',
  'PERQUIMANS',
  'PERSON',
  'PITT',
  'POLK',
  'RANDOLPH',
  'RICHMOND',
  'ROBESON',
  'ROCKINGHAM',
  'ROWAN',
  'RUTHERFORD',
  'SAMPSON',
  'SCOTLAND',
  'STANLY',
  'STOKES',
  'SURRY',
  'SWAIN',
  'TRANSYLVANIA',
  'TYRRELL',
  'UNION',
  'VANCE',
  'WARREN',
  'WASHINGTON',
  'WATAUGA',
  'WAYNE',
  'WILKES',
  'WILSON',
  'YADKIN',
  'YANCEY'
];

@Injectable()
export class CountyService {

  static number_of_counties = counties.length;

  nonOdysseyCounties: string[] = [];
  errors: string[] = [];
  nonOdysseyCountiesLoaded$ = new EventEmitter<boolean>();

  /**
    Returns an array of North Carolina county names (in uppercase). This method returns a new array each time
    it is invoked to avoid issues when a caller modifies the county array.
  **/
  static getCounties(): string[] {
    return [...counties];
  }

  constructor(private http: HttpClient) {}

  getNonOdysseyCounties(): string[] {
    return [...this.nonOdysseyCounties];
    //return [...counties];
  }

  setNonOdysseyCounties(coutiesList: string[]) {
    this.nonOdysseyCounties = coutiesList;
  }

  loadNonOdysseyCounties(): Observable<WrappedResponse> {
    const url = environment.proxyBaseUrl + 'criminal_cases/' + 'county';
    let params = new HttpParams();
    params = params.append('odyssey', 'NO');
    return this.http.get<WrappedResponse>(url, { params, observe: 'response' }).pipe(
      map((response) => response.body),
      catchError(this.handleError)
    )
  }
/* 
  getNonOdysseyCountiesLoadedEvent(): EventEmitter<boolean> {
    return this.nonOdysseyCountiesLoaded$;
  }
 */
  private handleError(error: HttpErrorResponse) {
    // TODO: if this error handling is consistent across all http calls,
    // we can push this code to CiprsHttp and avoid repeating the logic
    let errorMessage: string;
    if (error.status === 0 ||
        error.status >= 500) {
      console.log('error code = ' + error.status, error);
      errorMessage = 'Unable to reach the server for searchable county list. Please try again later.';
    } else {
      const wrappedErrorResponse = error.error || {};
      if (wrappedErrorResponse.responseCode === 404) {
        errorMessage = 'Server error: No searchable counties were found. Please try again later.';
      } else {
        errorMessage = 'Server error. Unable to retrieve searchable county list. Please try again later.';
      }
    }
    console.log('errorMessage=' + errorMessage);
    return new ErrorObservable(errorMessage);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/county.service.ts